"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementModels = void 0;
var ElementModels;
(function (ElementModels) {
    var ElementMode;
    (function (ElementMode) {
        ElementMode["single"] = "single";
        ElementMode["multiple"] = "multiple";
    })(ElementMode = ElementModels.ElementMode || (ElementModels.ElementMode = {}));
    var ElementType;
    (function (ElementType) {
        ElementType["text"] = "text";
        ElementType["richText"] = "rich_text";
        ElementType["number"] = "number";
        ElementType["multipleChoice"] = "multiple_choice";
        ElementType["dateTime"] = "date_time";
        ElementType["asset"] = "asset";
        ElementType["modularContent"] = "modular_content";
        ElementType["taxonomy"] = "taxonomy";
        ElementType["urlSlug"] = "url_slug";
        ElementType["guidelines"] = "guidelines";
        ElementType["snippet"] = "snippet";
        ElementType["custom"] = "custom";
    })(ElementType = ElementModels.ElementType || (ElementModels.ElementType = {}));
    var ContentItemElement = /** @class */ (function () {
        function ContentItemElement(data) {
            Object.assign(this, data);
        }
        return ContentItemElement;
    }());
    ElementModels.ContentItemElement = ContentItemElement;
    var ContentItemElementComponent = /** @class */ (function () {
        function ContentItemElementComponent(data) {
            Object.assign(this, data);
        }
        return ContentItemElementComponent;
    }());
    ElementModels.ContentItemElementComponent = ContentItemElementComponent;
    var ContentItemElementWithComponents = /** @class */ (function () {
        function ContentItemElementWithComponents(data) {
            Object.assign(this, data);
        }
        return ContentItemElementWithComponents;
    }());
    ElementModels.ContentItemElementWithComponents = ContentItemElementWithComponents;
})(ElementModels = exports.ElementModels || (exports.ElementModels = {}));
//# sourceMappingURL=elements.models.js.map